import axios from 'axios'
// import ordersList from './ordersList.js'
export default {
  getReasons ({commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: process.url + 'Agendamento/CancelReasons',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('loadReasons', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toastrAxiosError', error)
      })
    })
  },
  alterSchedule ({state, commit, rootGetters}, id) {
    // BUG: possivelmente o cancela está com erro
    commit('updateReason', id)
    return new Promise((resolve, reject) => {
      let schedule = state.selectedSchedule
      schedule.idReason = id
      commit('toggleAlteredScheduleSaving', true)
      commit('toggleScheduleEditing')
      commit('toggleLoadingCanceled')
      commit('toggleAlterDateModal', false)
      axios({
        method: 'post',
        url: process.url + 'Agendamento/AlterSchedule',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        },
        data: schedule
      })
      .then((response) => {
        commit('selectSchedule', response.data.resultado)
        commit('updateRegisteredSchedules', response.data.resultado)
        commit('toastr', {
          color: 'success',
          texto: 'Dados alterados com sucesso'
        })
        commit('toggleLoadingCanceled', false)
        commit('toggleAlteredScheduleSaving', false)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toastrAxiosError', error)
        commit('toggleLoadingCanceled', false)
        commit('toggleAlteredScheduleSaving', false)
      })
    })
  },
  sendEmail ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingCanceled', true)
      commit('toggleSendEmailModal', false)
      axios({
        method: 'post',
        url: process.url + 'Agendamento/SendEmails',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        },
        data: state.selectedSchedule
      })
      .then((response) => {
        commit('selectSchedule', response.data.resultado)
        commit('updateRegisteredSchedules', response.data.resultado)
        commit('toastr', {
          color: 'success',
          texto: 'E-mails encaminhados'
        })
        commit('toggleLoadingCanceled', false)
        commit('toggleScheduleDetailsModal', false)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toastrAxiosError', error)
        commit('toggleLoadingCanceled', false)
      })
    })
  },
  showOrders ({state, commit, rootGetters}, id) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      axios({
        method: 'get',
        url: process.url + 'Pedido/BySchedule?id=' + id,
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('loadScheduleOrders', response.data.resultado)
        commit('toggleScheduleOrdersModal', true)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingMounted', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  cancelSchedule ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingCanceled', true)
      axios({
        method: 'post',
        url: process.url + 'Agendamento/CancelSchedule',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        },
        data: state.selectedSchedule
      })
      .then((response) => {
        commit('updateRegisteredSchedules', response.data.resultado)
        commit('toastr', {
          color: 'success',
          texto: 'Agendamento cancelado com sucesso'
        })
        commit('toggleLoadingCanceled', false)
        commit('toggleScheduleDetailsModal', false)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toastrAxiosError', error)
        commit('toggleLoadingCanceled', false)
      })
    })
  },
  finishSchedule ({state, commit, rootGetters}) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingFinished', true)
      axios({
        method: 'post',
        url: process.url + 'Agendamento/FinishSchedule',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        },
        data: state.selectedSchedule
      })
      .then((response) => {
        commit('updateRegisteredSchedules', response.data.resultado)
        commit('toggleLoadingFinished', false)
        commit('toggleScheduleDetailsModal', false)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toastrAxiosError', error)
        commit('toggleLoadingFinished', false)
      })
    })
  },
  saveSchedule ({state, commit, rootGetters, dispatch}, payload = false) {
    commit('toggleLoadingSaved', true)
    return new Promise((resolve, reject) => {
      // BUG: alterar todos os date para dates ajustado?
      // let a = state.selectedSchedule
      // a.dates = a.date
      // a.date = null
      axios({
        method: 'post',
        url: process.url + 'Agendamento/SaveSchedule',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        },
        data: state.selectedSchedule
      })
      .then((response) => {
        commit('appendNewSchedule', response.data.resultado)
        commit('selectSchedule', response.data.resultado)
        commit('toggleScheduleDetailsModal', false)
        commit('toggleLoadingSaved', false)
        commit('toastr', {
          color: 'success',
          texto: 'Agendamento realizado com sucesso'
        })
        if (payload && response.data.resultado.id) {
          dispatch('selectSchedule', response.data.resultado.id)
        }
        // commit('toggleScheduleDetailsModal', true)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description,
              time: 5000
            })
          }
        }
        commit('toastrAxiosError', error)
        commit('toggleLoadingSaved', false)
      })
    })
  },
  searchCondominiumCnpj ({state, commit, rootGetters}) {
    // BUG: parametros fixos, por causa do back end
    if (state.searchCnpj.length !== 14) {
      return
    }
    return new Promise((resolve, reject) => {
      commit('toggleLoadingCondominium', true)
      axios({
        method: 'get',
        url: process.url + 'Agendamento/SearchDoc?cnpj=' + state.searchCnpj + '&param=P_PARCERIAJUPITER&conteudo=S',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        if (response.data.resultado.condominium !== null) {
          commit('loadCondominium', response.data.resultado.condominium)
        } else {
          commit('errorSearchCnpj', true)
        }
        commit('toggleLoadingCondominium', false)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingCondominium', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  newScheduleSelectedItem ({commit}, payload) {
    commit('toggleScheduleDetailsModal', true)
    commit('selectScheduleItem', payload)
  },
  selectSchedule ({state, commit, rootGetters}, scheduleId) {
    if (scheduleId === '') {
      commit('toggleScheduleDetailsModal', true)
    } else {
      commit('toggleLoadingMounted', true)
      return new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: process.url + 'Agendamento/DetailSchedule?schedule=' + scheduleId,
          timeout: 200000,
          headers: {
            'Token': rootGetters.token
          }
        })
        .then((response) => {
          commit('toggleLoadingMounted', false)
          commit('selectSchedule', response.data.resultado)
          commit('toggleScheduleDetailsModal', true)
        })
        .catch((error) => {
          if (error.request.response !== '') {
            var erros = JSON.parse(error.request.response).preErros
            var description = ''
            if (erros.length > 0) {
              erros.forEach(element => {
                description = description + ' ' + element
              })
            } else {
              description = erros[0]
            }
            if (erros !== undefined) {
              commit('toastr', {
                color: 'error',
                texto: description
              })
            }
          }
          commit('toggleLoadingMounted', false)
          commit('toastrAxiosError', error)
        })
      })
    }
  },
  // gets
  getScheduledSchedule ({state, commit, rootGetters}, id) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      axios({
        method: 'get',
        url: process.url + 'Agendamento/Scheduled',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('loadSchedules', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingMounted', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  getAwaitSchedule ({state, commit, rootGetters}, id) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      axios({
        method: 'get',
        url: process.url + 'Agendamento/AwaitSchedules',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('loadSchedules', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingMounted', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  getFinishedSchedule ({state, commit, rootGetters}, id) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      axios({
        method: 'get',
        url: process.url + 'Agendamento/AllFinishedSchedule',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('loadSchedules', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingMounted', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  getCanceledSchedule ({state, commit, rootGetters}, id) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingMounted', true)
      axios({
        method: 'get',
        url: process.url + 'Agendamento/AllCanceledSchedule',
        timeout: 200000,
        headers: {
          'Token': rootGetters.token
        }
      })
      .then((response) => {
        commit('toggleLoadingMounted', false)
        commit('loadSchedules', response.data.resultado)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingMounted', false)
        commit('toastrAxiosError', error)
      })
    })
  },
  addOrRemoveItemSchedule ({state, commit, rootGetters}, payload) {
    const itens = state.selectedItens.filter((elem) => {
      return elem.id === payload.id
    })

    if (itens.length > 0) {
      commit('removeItemForScheduled', payload)
    } else {
      commit('addItemForScheduled', payload)
    }
    // if (state.selectedItens.indexOf(payload) === -1) {
    // } else {
    // }
  },
  setErrorDisponibilityInterval ({state, commit, rootGetters}, payload) {
    if (payload) {
      commit('toastr', {
        color: 'error',
        texto: 'Intervalo não selecionado'
      })
    }
    state.errorDisponibilityInterval = payload
  }
  // getAllScheduled ({state, commit, rootGetters}, id) {
  //   return new Promise((resolve, reject) => {
  //     commit('toggleLoadingMounted', true)
  //     axios({
  //       method: 'get',
  //       url: process.url + 'Agendamento/AllScheduled',
  //       timeout: 200000,
  //       headers: {
  //         'Token': rootGetters.token
  //       }
  //     })
  //     .then((response) => {
  //       commit('toggleLoadingMounted', false)
  //       commit('loadSchedules', response.data.resultado)
  //     })
  //     .catch((error) => {
  //       commit('toggleLoadingMounted', false)
  //       commit('toastrAxiosError', error)
  //     })
  //   })
  // }
}



// WEBPACK FOOTER //
// ./src/store/agendamento/actions.js